export const HERO_TOPICS = [
  { id: 'setup', label: 'Dragon software setup & first-run help' },
  { id: 'mic', label: 'Microphone setup & voice calibration' },
  { id: 'ui', label: 'Dragon failed to launch UI fixes' },
  { id: 'install', label: 'Installation & activation problems' },
  { id: 'error', label: 'Dragon error code recovery help' },
];

export const PRODUCTS = [
  {
    id: 'pro-15',
    name: 'Dragon Professional Individual v15',
    blurb:
      'Reliable voice typing and custom commands for Windows professionals who need accuracy across everyday work apps.',
    image: '/images/product-pro.jpg',
    rating: 5,
    priceWas: 699,
    priceNow: 549,
  },
  {
    id: 'medical-16',
    name: 'Dragon Medical Practice Edition',
    blurb:
      'Clinical speech recognition built for charts, EHR notes, and specialty terms used in busy practices.',
    image: '/images/product-medical.jpg',
    rating: 5,
    priceWas: 1699,
    priceNow: 1499,
  },
  {
    id: 'home-15',
    name: 'Dragon Home Edition v15',
    blurb:
      'Easy home dictation for email, documents, and everyday PC control with a simpler feature set.',
    image: '/images/product-home.jpg',
    rating: 4,
    priceWas: 229,
    priceNow: 179,
  },
  {
    id: 'group-15',
    name: 'Dragon Professional Group',
    blurb:
      'Shared profiles and admin-friendly licensing for teams that dictate across the same Windows workflows.',
    image: '/images/product-group.jpg',
    rating: 5,
    priceWas: 999,
    priceNow: 849,
  },
  {
    id: 'mic-kit',
    name: 'Dragon Mic & Accuracy Kit',
    blurb:
      'Headset guidance and calibration support packaged for clearer recognition when your current mic holds you back.',
    image: '/images/product-mic.jpg',
    rating: 4,
    priceWas: 149,
    priceNow: 99,
  },
];

export const STATS = [
  { value: '15+', label: 'Years helping users' },
  { value: '220+', label: 'Support specialists' },
  { value: '8,500+', label: 'Helped customers' },
  { value: '40k+', label: 'Support sessions' },
];

export const FAQS = [
  {
    q: 'What is Dragon software, and how does it work?',
    a: 'Dragon NaturallySpeaking converts speech into text and computer commands. After a short voice profile setup, you can dictate into documents, email, and many Windows apps. Our team can help refine accuracy and microphone settings when something goes wrong.',
  },
  {
    q: 'Is Dragon Help an official Nuance or Microsoft site?',
    a: 'No. Dragon Help (dragonhelpss.online) is an independent technical support and sales assistance service operated by Nodex Global LLC. We are not affiliated with, endorsed by, or sponsored by Nuance Communications, Microsoft Corporation, or the makers of Dragon software. Product names are trademarks of their respective owners and are used only for identification.',
  },
  {
    q: 'Do you provide free technical support for Dragon products?',
    a: 'Yes. Complimentary guidance is available for common setup, microphone configuration, installation failures, activation questions, and frequent error codes. If your issue needs extended remote troubleshooting, hardware diagnosis, or OS recovery, we will explain any optional paid options before work begins.',
  },
  {
    q: 'Which Dragon versions do you support?',
    a: 'We assist with current and recent Dragon Home, Professional, Legal, and Medical releases on supported Windows systems. Share your exact version and Windows build so we can follow the correct fix path.',
  },
  {
    q: 'How do product purchases and pricing work?',
    a: 'Listed prices are estimates for licensed editions and may change until our team confirms availability, edition, and compatibility with your system. Chat or email to complete an order. You will receive order details before payment is finalized.',
  },
  {
    q: 'Can you help if Dragon fails to launch or shows an error code?',
    a: 'Yes. Failed UI launches, microphone issues, and numbered error codes are common requests. Share the exact on-screen message and we will walk you through repair steps during live chat or email follow-up.',
  },
];
